'use strict';
//**********************************************************************************************************************
// SERIESページと商品ページで使用している
//**********************************************************************************************************************
window.addEventListener("DOMContentLoaded", () => {
    //movieがある場合の設定================================================================================================
    if (document.getElementById("js-seriesDtl__mv") != null) {
        //リサイズ時の再読み込み設定（動画の切り替えのため）====================================================================
        let resizeTimer;
        let lastWindowWidth = window.innerWidth;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                const currentWidth = window.innerWidth;
                if (
                    (lastWindowWidth < 480 && currentWidth >= 480) ||
                    (lastWindowWidth >= 480 && currentWidth < 480)
                ) {
                    location.reload();
                }
                lastWindowWidth = currentWidth;
            }, 200);
        });
        //Swiper / videoの設定===========================================================================================
        // Swiperインスタンスを外部で宣言
        let movieSwiper;
        const videos = document.querySelectorAll(".seriesDtl__mv__slide__video");
        videos.forEach((video) => {
            video.currentTime = 0;
            video.pause();
        });

        const stopBtn = document.getElementById("js-seriesDtl__mv__control__stop");
        let isPlaying = true;
        let isReturning = false;

        movieSwiper = new Swiper("#js-seriesDtl__mv", {
            speed: 1200,
            loop: false,
            preventInteractionOnTransition: true,
            slidesPerView: 1.04,
            spaceBetween: 15,
            centeredSlides: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "swiper-slide-active--main",
            navigation: {},
            pagination: {
                el: ".swiper-pagination--indicator",
                clickable: true,
                spaceBetween: 15,
            },
            on: {
                //初回ロード時に1枚目の動画が画面に表示されたら再生開始
                init: function () {
                    const firstSlideVideo = this.slides[0].querySelector("video");
                    if (firstSlideVideo) {
                        firstSlideVideo.currentTime = 0;
                        firstSlideVideo.pause();
                        //IntersectionObserver を使用して、要素が表示領域に入ったタイミングで動画を再生
                        const observer = new IntersectionObserver((entries) => {
                            entries.forEach((entry) => {
                                if (entry.isIntersecting && isPlaying) {
                                    firstSlideVideo.play();
                                    firstSlideVideo.addEventListener("ended", () => {
                                        //動画が終わったら1秒停止して次のスライドへ
                                        setTimeout(() => this.slideNext(), 1000);
                                    });
                                    observer.unobserve(entry.target);
                                }
                            });
                        });
                        observer.observe(firstSlideVideo);
                    }
                },
                slideChange: function () {
                    //スライド変更時の動画制御
                    videos.forEach((video) => {
                        video.pause();
                        video.removeEventListener("ended", video.handleVideoEnd);
                    });

                    if (!isPlaying) return;

                    const activeSlide = this.slides[this.activeIndex];
                    const activeVideo = activeSlide.querySelector("video");

                    if (activeVideo) {
                        activeVideo.currentTime = 0;
                        activeVideo.play();

                        // リスナー削除してから再登録（重複防止）
                        activeVideo.removeEventListener("ended", activeVideo.handleVideoEnd);
                        activeVideo.handleVideoEnd = () => {
                            setTimeout(() => {
                                if (this.activeIndex === this.slides.length - 1) {
                                    stopBtn.classList.add("js-seriesDtl__mv__control__stop--return");
                                    isReturning = true;
                                    videos.forEach((video) => {
                                        video.currentTime = 0;
                                    });
                                } else {
                                    this.slideNext();
                                }
                            }, 1000);
                        };
                        activeVideo.addEventListener("ended", activeVideo.handleVideoEnd);
                    }
                },
                slideChangeTransitionStart: function () {
                    const activeSlide = this.slides[this.previousIndex];
                    const activeVideo = activeSlide.querySelector("video");
                    if (activeVideo) {
                        activeVideo.pause();
                    }
                },
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                },
                1280: {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                },
            },
        });

        // `.js-seriesDtl__mv__control__stop--return` をクリックで最初に戻す
        if (stopBtn) {
            stopBtn.addEventListener("click", () => {
                if (!movieSwiper) return;

                if (stopBtn.classList.contains("js-seriesDtl__mv__control__stop--return")) {
                    stopBtn.classList.remove("js-seriesDtl__mv__control__stop--return");
                    movieSwiper.slideTo(0);
                    isReturning = false;

                    const firstSlideVideo = movieSwiper.slides[0].querySelector("video");
                    if (firstSlideVideo) {
                        firstSlideVideo.currentTime = 0;
                        firstSlideVideo.play();
                    }
                    return;
                }

                const activeSlide = movieSwiper.slides[movieSwiper.activeIndex];
                const activeVideo = activeSlide.querySelector("video");
                const paginationBullets = document.querySelectorAll(".swiper-pagination-bullet");

                if (activeVideo) {
                    if (isPlaying) {
                        activeVideo.pause();
                        stopBtn.classList.add("js-seriesDtl__mv__control__stop--play");

                        paginationBullets.forEach((bullet) => {
                            bullet.classList.add("js-seriesDtl__mv__control__indicator--paused");
                        });
                    } else {
                        activeVideo.play();
                        stopBtn.classList.remove("js-seriesDtl__mv__control__stop--play");

                        // ここで `handleVideoEnd` を強制リセット
                        activeVideo.removeEventListener("ended", activeVideo.handleVideoEnd);
                        activeVideo.handleVideoEnd = () => {
                            setTimeout(() => {
                                if (movieSwiper.activeIndex === movieSwiper.slides.length - 1) {
                                    stopBtn.classList.add("js-seriesDtl__mv__control__stop--return");
                                    isReturning = true;
                                } else {
                                    movieSwiper.slideNext();
                                }
                            }, 1000);
                        };
                        activeVideo.addEventListener("ended", activeVideo.handleVideoEnd);

                        paginationBullets.forEach((bullet) => {
                            bullet.classList.remove("js-seriesDtl__mv__control__indicator--paused");
                        });
                    }
                    isPlaying = !isPlaying;
                }
            });
        }

        // `.swiper-pagination-bullet` がクリックされたら `.js-seriesDtl__mv__control__stop--return` を削除
        const paginationBullets = document.querySelectorAll(".swiper-pagination-bullet");
        paginationBullets.forEach((bullet) => {
            bullet.addEventListener("click", () => {
                stopBtn.classList.remove("js-seriesDtl__mv__control__stop--return");
                isReturning = false;
            });
        });
    }

    //FEATURE部分のスライダー
    const mySwiper_series1 = new Swiper('.js-c-features__cnt__sec__images__swiper--1', {
        // Optional parameters
        loop: true,
        slidesPerView:1,
        spaceBetween: 50,

        // If we need pagination
        pagination: {
            el: '.js-c-features__cnt__sec__images__swiper-pagination1',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.js-c-features__cnt__sec__images__swiper-next1',
            prevEl: '.js-c-features__cnt__sec__images__swiper-prev1',
        },

        breakpoints:{
            750:{
                slidesPerView:1,
                spaceBetween:30,
                centeredSlides: true,
                pagination: {
                    el: '.js-c-features__cnt__sec__images__swiper-pagination1',
                },
            }
        }
    });

    const mySwiper_series2 = new Swiper('.js-c-features__cnt__sec__images__swiper--2', {
        // Optional parameters
        loop: true,
        slidesPerView:1,
        spaceBetween: 50,

        // If we need pagination
        pagination: {
            el: '.js-c-features__cnt__sec__images__swiper-pagination2',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.js-c-features__cnt__sec__images__swiper-next2',
            prevEl: '.js-c-features__cnt__sec__images__swiper-prev2',
        },

        breakpoints:{
            750:{
                slidesPerView:1,
                spaceBetween:30,
                centeredSlides: true,
                pagination: {
                    el: '.js-c-features__cnt__sec__images__swiper-pagination2',
                },
            }
        }
    });

    const mySwiper_series3 = new Swiper('.js-c-features__cnt__sec__images__swiper--3', {
        // Optional parameters
        loop: true,
        slidesPerView:1,
        spaceBetween: 50,

        // If we need pagination
        pagination: {
            el: '.js-c-features__cnt__sec__images__swiper-pagination3',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.js-c-features__cnt__sec__images__swiper-next3',
            prevEl: '.js-c-features__cnt__sec__images__swiper-prev3',
        },

        breakpoints:{
            750:{
                slidesPerView:1,
                spaceBetween:30,
                centeredSlides: true,
                pagination: {
                    el: '.js-c-features__cnt__sec__images__swiper-pagination3',
                },
            }
        }
    });

    const featureFadeSwiper1 = new Swiper('#js-feature-fade-swiper1', {
        autoplay: {
            delay: 1200,
            disableOnInteraction: false,
        },
        loop: true,
        speed: 1600,
        slidesPerView: 1,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        effect: "fade",
    });
});